import classNames from 'classnames';
import { SkeletonSportTable } from 'components/skeletonSportTable';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import useWindowSize from 'hooks/useWindowSize';
import { useTypedSelector } from 'lib/centralStore';
import React from 'react';
import { ScommesseFallbackProps } from '.';
import styles from './ScommesseFallback.module.scss';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';

export const Loader = ({ isVisible }: ScommesseFallbackProps) => {
  const { isMobile } = useWindowSize();
  const isCarrelloOpen = useTypedSelector(selectIsOpenCarrello);

  return (
    <React.Fragment>
      <SkeletonSportTable
        key={`skeleton-sport-table-${isVisible}`}
        className={classNames(styles.loader, {
          [styles.hidden]: !isVisible,
          [styles.noMargin]: isMobile || isCarrelloOpen,
        })}
      />
      <ScommesseEsitoTipoBox
        className={styles.hidden}
        key={'scommesse-esito-tipobox-loader'}
        scommessaKey="-"
        infoAggiuntivaKey="-"
        keyEsito="-"
      />
    </React.Fragment>
  );
};
